import { create } from 'zustand';
import i18n from 'i18n';
import { ApiUtils, GetStatementsResponse, StatementsApi } from '@shared/api';
import type { BaseReturn } from '@shared/types';

interface UseGetStatementsStore {
  loading: boolean;
  data: GetStatementsResponse[];
  error?: string | null;
  get: (id: number) => Promise<BaseReturn<GetStatementsResponse[] | null>>;
  clear: () => void;
}

export const useGetStatementsStore = create<UseGetStatementsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  get: async (id) => {
    try {
      set({ loading: true, data: [], error: null });
      const result = await StatementsApi.getStatements(id);
      set({ loading: false, data: result ?? null });
      return { loading: false, data: result ?? null };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, data: [], error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: [], error: null }),
}));
